module.exports = __webpack_public_path__ + "static/media/11756541_969808823040540_1546083876_n.0f49f6ea.jpg";